import { EmptyButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/EmptyButtonGroup'
import { MedicalReleaseDetailsButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseDetailsButtonGroup'
import { MedicalReleaseDetailsPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseDetailsPrompt'
import { MedicalReleaseSignatureButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseSignatureButtonGroup'
import { MedicalReleaseSignaturePrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseSignaturePrompt'
import { ShareTrialStep } from '@components/app/ApplySuccessPage/PostApplyPrompt/ShareTrialStep.client'
import ShareYourStoryButtonGroup from '@components/app/ApplySuccessPage/PostApplyPrompt/ShareYourStoryButtonGroup'
import { ShareYourStoryPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/ShareYourStoryPrompt'
import WhyApplyToTrialButtonGroup from '@components/app/ApplySuccessPage/PostApplyPrompt/WhyApplyToTrialButtonGroup'
import WhyApplyToTrialPrompt from '@components/app/ApplySuccessPage/PostApplyPrompt/WhyApplyToTrialPrompt'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { PatientCallToSiteStep } from './PatientCallToSiteStep.client'
import { PatientNavigatorPhoneCallStep } from './PatientNavigatorPhoneCallStep.client'
import { PhoneCallAvailabilityButtonGroup } from './PhoneCallAvailabilityButtonGroup'
import { PhoneCallAvailabilitySelectorQuestion } from './PhoneCallAvailabilitySelectorQuestion'
import SaveStudyTeamContactButtonGroup from './SaveStudyTeamContactButtonGroup'
import SaveStudyTeamContactStep from './SaveStudyTeamContactStep'
import { ScreeningVisitQualificationStep } from './ScreeningVisitQualification/ScreeningVisitQualificationStep.client'
import ShareTrialButtonGroup from './ShareTrialButtonGroup'
import type { PostApplyStep } from './stepTypes'

export type PostApplyFlowStep = {
  buttonGroup: (props: ApplySuccessPageProps) => JSX.Element
  hideBurger?: boolean
  hideFooter?: boolean
  questionText?: string
  stepContent: (props: ApplySuccessPageProps) => JSX.Element
  stepId: PostApplyStep
}

/** @see POST_APPLY_STEPS for corresponding order */
export const PostApplyFlowSteps: PostApplyFlowStep[] = [
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Connect with the Clinical Trial Coordinator',
    stepContent: PatientCallToSiteStep,
    stepId: 'patient-call-to-site-q',
  },
  {
    buttonGroup: MedicalReleaseDetailsButtonGroup,
    questionText: "Next, let's request medical records on your behalf",
    stepContent: MedicalReleaseDetailsPrompt,
    stepId: 'medical-release-consent',
  },
  {
    buttonGroup: MedicalReleaseSignatureButtonGroup,
    questionText: 'Complete Your Medical Record Release',
    stepContent: MedicalReleaseSignaturePrompt,
    stepId: 'medical-release-signature',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Connect with the Clinical Trial Coordinator',
    stepContent: PatientCallToSiteStep,
    stepId: 'patient-call-to-site',
  },
  {
    buttonGroup: PhoneCallAvailabilityButtonGroup,
    questionText: 'Schedule a call from the study team',
    stepContent: PhoneCallAvailabilitySelectorQuestion,
    stepId: 'phone-call-availability',
  },
  {
    buttonGroup: SaveStudyTeamContactButtonGroup,
    questionText: 'Save the study team to your contacts',
    stepContent: SaveStudyTeamContactStep,
    stepId: 'save-study-team-contact',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Confirm details to a few of your responses',
    stepContent: PatientNavigatorPhoneCallStep,
    stepId: 'patient-navigator-agent',
  },
  {
    buttonGroup: WhyApplyToTrialButtonGroup,
    questionText: 'Why did you apply to this trial?',
    stepContent: WhyApplyToTrialPrompt,
    stepId: 'why-apply',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'placeholder',
    stepContent: ScreeningVisitQualificationStep,
    stepId: 'screening-visit-qualification',
  },
  {
    buttonGroup: ShareTrialButtonGroup,
    questionText: 'Help others find this trial',
    stepContent: ShareTrialStep,
    stepId: 'share-trial',
  },
  {
    buttonGroup: ShareYourStoryButtonGroup,
    questionText: 'Be a Hero, Share Your Story',
    stepContent: ShareYourStoryPrompt,
    stepId: 'share-story',
  },
]
